const TAG_REGEX = /#([\p{L}\p{N}_]+)/gu;

export default function extractTags(text) {
  const tags = new Set();
  for (const match of text.matchAll(TAG_REGEX)) tags.add(match[1].toLowerCase());
  return [...tags];
}
